export default "__VITE_ASSET__DKZyVo1___"